import src from "IMAGE";
export default { src, width: 1223, height: 131, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAC0lEQVR42mPgIAAAEKEBAa/HUvcAAAAASUVORK5CYII="};
